import * as React from "react";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { Hotel } from "src/typings/microserviceModels/hotels-flex-module";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { useSubtextPriceLockup } from "./useSubtextPriceLockup";

interface UitkPriceLockupProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

export const PriceLockupDefault = ({
  className,
  hotel,
  priceA11y,
  strikeThroughPrice,
  align,
}: UitkPriceLockupProps) => {
  const { formattedPrice: lockupPrice } = hotel;
  const { priceSubtextFirst, priceSubtextStandard } = useSubtextPriceLockup(hotel);

  const props = {
    lockupPrice,
    priceSubtextFirst,
    priceSubtextStandard,
    a11yPrice: priceA11y?.getA11yText() || "",
    strikeThroughPrice,
    align,
    className,
  };

  return <UitkPriceLockup {...props} />;
};

export default PriceLockupDefault;
